<p class="text-center">
  Cerrando sesión.
</p>
